module.exports = __webpack_public_path__ + "static/media/TeamsInactive.243292f0.png";